import React, { useMemo } from 'react';
import SegmentedPolylineOverlay from './SegmentedPolylineOverlay';

const rsrqColors = [
  '#9c27b0', // purple - unknown
  '#d32f2f', // red - very poor
  '#f57c00', // orange - poor
  '#fbc02d', // yellow - fair
  '#1976d2', // blue - good
  '#388e3c', // green - excellent
];

const ranges = [
  { min: -3, max: 0, color: rsrqColors[5], description: 'Excellent' },
  { min: -6, max: -3, color: rsrqColors[4], description: 'Good' },
  { min: -9, max: -6, color: rsrqColors[3], description: 'Fair' },
  { min: -12, max: -9, color: rsrqColors[2], description: 'Poor' },
  { min: -20, max: -12, color: rsrqColors[1], description: 'Very Poor' },
  { min: -Infinity, max: -20, color: rsrqColors[0], description: 'Unknown' },
];

const legendFormatter = r =>
  r.min === -Infinity
    ? `Unknown`
    : r.max === 0
    ? `${r.min}+ dB (${r.description})`
    : `${r.min} to ${r.max} dB (${r.description})`;

export default function LteRSRQOverlay({ routes }) {
  // routes: array of segments (arrays of points)
  const allPoints = useMemo(() => routes.flat(), [routes]);

  // Only render overlay if there are points
  if (!allPoints.length) return null;

  return (
    <SegmentedPolylineOverlay
      segments={routes}
      valueSelector={pt => pt.lteRSRQ ?? -Infinity}
      ranges={ranges}
      legendTitle="LTE Quality"
      legendFormatter={legendFormatter}
      units="dB"
      discrete={false}
    />
  );
}